import { ModelWrapper } from "app/pages/company/component/ModelWrapper";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "sr/helpers";
import { AppDispatch } from "sr/redux/store";
import { useAuth } from "./core/Auth";
import { fetchcleaner } from "sr/redux/reducers/cleaner";
import { fetchCompany } from "sr/redux/reducers/company";
import { fetchIndividual } from "sr/redux/reducers/individual";
import { fetchSupervisor } from "sr/redux/reducers/supervisor";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { updateCleaner } from "sr/utils/api/cleaner/updateCleaner";
import { updateCompany } from "sr/utils/api/company/updateCompany";
import { updateIndividual } from "sr/utils/api/individual/updateIndividual";
import { updateSupervisor } from "sr/utils/api/company/workorder/updateSupervisor";

export const TermsAgreePopup = () => {
    const [showModal, setShowModal] = useState(false)
    const dispatch = useDispatch<AppDispatch>()
    const {userType, isAuthenticate} = useAuth()
    const [userId, setUserId] = useState<string>('')
    const [loader, setLoader] = useState(false)
    useEffect(()=>{
        const getdetails = getUserDetails()
        setUserId(getdetails?.user_id)
    },[])
    let data = useSelector((state:any)=> {
        if(userType==='cleaner'){
            return state?.cleaner?.data
        }
        else if(userType==='company'){
            return state?.company?.data
        }
        else if(userType==='individual'){
            return state?.individual?.data
        }
       else if(userType==='supervisor'){
            return state?.supervisor?.data
        }
        else{
            return null
        }
    })
    
    useEffect(()=>{
            if(data && data?.hasUserAcceptedTerms===false){
                setShowModal(true)
            }
    },[data])
    useEffect(()=>{
        if(userId && userType && isAuthenticate){
            if(!data){
                if(userType==='cleaner'){
            dispatch(fetchcleaner({id:userId}))
                }
                if(userType==='company'){
                    dispatch(fetchCompany({id:userId}))
                }
                if(userType==='individual'){
                    dispatch(fetchIndividual({id:userId}))
                }
                if(userType==='supervisor'){
                    dispatch(fetchSupervisor({id:userId}))
                }

            }
        }
    },[userId, userType, data, isAuthenticate])
    const AgreementHandle = async ()=>{
        setLoader(true)
            const payload = {
                id:userId,
                hasUserAcceptedTerms:true
            }
            let result
        if(userType==='cleaner'){
            result = await updateCleaner(payload)
        }  
        if(userType==='company'){
            result = await updateCompany(payload)
        }  
        if(userType==='individual'){
            result = await updateIndividual(payload)
        }
        if(userType==='supervisor'){
            result = await updateSupervisor(payload)
        }
        if(result?.success===true){
            setLoader(false)
            setShowModal(false)
            if(userType==='cleaner'){
            dispatch(fetchcleaner({id:userId}))
                }
                if(userType==='company'){
                    dispatch(fetchCompany({id:userId}))
                }
                if(userType==='individual'){
                    dispatch(fetchIndividual({id:userId}))
                }
                if(userType==='supervisor'){
                    dispatch(fetchSupervisor({id:userId}))
                }
        }
    }
  return (<>
  {showModal &&
    <ContentWithSpinner loader={loader} >
<ModelWrapper showModal={showModal} ModelWrapper
 rounded="rounded-[10px]"
 background="bg-[#00000099]"
 position="fixed"
 opacity="opacity-100"
 topPosition="top-[5%]"
 rightPosition="inset-0"
 width="w-[50%] mx-auto">
<div>
    <div className="py-3 border-b border-neutral-200">
    <h1 className="mx-10 text-xl font-semibold">Terms and Conditions</h1>
    </div>
    <div className="mx-10 py-3 flex flex-col space-y-3">
    <div className="pb-5">Welcome to our website. By accessing or using this site, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
</div>
<p>
    By using this website, you agree to be legally bound by these terms and our Privacy Policy. If you do not agree, please do not use the site.


</p>
<p>
    You may use this website for lawful purposes only. You may not use it to post or transmit any material that is unlawful, harmful, threatening, abusive, defamatory, or otherwise objectionable.


</p>
<p>
    If you create an account, you are responsible for maintaining the confidentiality of your login information and all activities under your account.


</p>
<p>
    All content on this site, including text, graphics, logos, and images, is the property of this website or its licensors and is protected by applicable intellectual property laws.


</p>
<p>
    We reserve the right to modify these terms at any time. Your continued use of the website after changes are made constitutes your acceptance of those changes.


</p>
<p>
    We do our best to keep this website running smoothly, but we do not guarantee that it will always be available, error-free, or secure. We are not liable for any loss or damage that may result from using our site.


</p>
<p>
    We may terminate or suspend access to our site immediately, without prior notice, if you breach these terms.
</p>
<div className="flex justify-end">
    <Button onClick={AgreementHandle} childCSS="w-full justify-center text-base" className={'bg-[#ff39b3] capitalize text-white hover:bg-navy p-2 w-24 rounded-3xl mr-3 font-bold'} text={'Accept'}></Button>
</div>
</div></div>
</ModelWrapper> 
</ContentWithSpinner>
} 
</>
);
};
